import {Button, Typography} from '@mui/material';
import {FC} from 'react';
import {useNavigate} from 'react-router-dom';

interface InvoiceNumberLinkProps {
    invoiceId?: number;
    invoiceNumber?: string;
}

export const InvoiceNumberLink: FC<InvoiceNumberLinkProps> = ({invoiceId, invoiceNumber}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (invoiceId) {
            navigate(`/app/invoices/${invoiceId}`);
        }
    };

    return (
        <Button
            onClick={handleClick}
            sx={{p: 0, justifyContent: 'flex-start', textTransform: 'none', minWidth: 0}}
        >
            <Typography
                variant="subtitle2"
                color="primary.main"
            >
                {invoiceNumber || `#${invoiceId}`}
            </Typography>
        </Button>
    );
};
